import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useForgotPasswordMutation } from "../app/api/console/consoleAuthApiSlice";
import LogoWordmark from "../assets/zenyt_logo_wordmark.svg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sentMessage, setSentMessage] = useState(null);
  const [error, setError] = useState(null);
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const data = await forgotPassword({ email }).unwrap();
      setSentMessage(data.message);
    } catch (err) {
      setError(err.data?.detail || "Something went wrong. Try again in a few minutes.");
    }
  };

  return (
    <div className='flex min-h-screen items-center justify-center bg-gradient-to-br from-sidebar-gradient-from to-sidebar-gradient-to font-sans'>
      <div className='w-full max-w-sm'>
        <div className='bg-white rounded-2xl shadow-xl p-8'>
          <div className='flex flex-col items-center mb-8'>
            <img src={LogoWordmark} alt='Zenyt' className='h-7 mb-3' />
            <span className='text-text-tertiary text-body-sm'>Reset your Console password</span>
          </div>

          {sentMessage ? (
            <div className='space-y-4'>
              <div className='px-3 py-2 text-body-xs text-text-secondary bg-surface-neutral rounded-lg text-center'>
                {sentMessage}
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className='space-y-4'>
              <div>
                <label htmlFor='email' className='block text-body-xs font-medium text-text-secondary mb-1.5'>
                  Email
                </label>
                <input
                  id='email'
                  name='email'
                  type='email'
                  autoComplete='email'
                  required
                  className='w-full px-3.5 py-2.5 text-body-sm text-text-primary bg-surface-neutral rounded-xl border border-border-subtle focus:outline-none focus:ring-2 focus:ring-accent-purple/30 focus:border-accent-purple/50 placeholder:text-text-tertiary transition-all'
                  placeholder='you@company.com'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {error && (
                <div className='px-3 py-2 text-body-xs text-severity-high bg-severity-high/5 rounded-lg text-center'>
                  {error}
                </div>
              )}

              <button
                type='submit'
                disabled={isLoading}
                className='w-full py-2.5 text-body-sm font-semibold text-white bg-button-primary rounded-xl hover:bg-button-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2'>
                {isLoading ? "Sending..." : "Send reset link"}
              </button>
            </form>
          )}

          <div className='mt-6 text-center'>
            <Link to='/login' className='text-body-xs text-accent-purple hover:underline'>
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
